import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ToneOfVoicePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "ToneOfVoicePopup" */ './Container'),
  'popup'
);
